import { useState } from "react";
import { Typography } from "@mui/material";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import Input from "@components/Input/Input";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";

const LANG_BASE = "vessel-call.port-services";
const POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;
const MAX_DIGITS = 9;

const SparesField = () => {
  const { setSpares, errors, setErrors } = usePortServicesFlow();
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");
  const [hasMaxDigitsError, setHasMaxDigitsError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value === "") {
      setInputValue("");
      setSpares(undefined);
      setHasMaxDigitsError(false);
      if (errors.spares) {
        setErrors({
          ...errors,
          spares: undefined,
        });
      }
      return;
    }

    if (!POSITIVE_INTEGER_PATTERN.test(value)) return;

    if (value.length > MAX_DIGITS) {
      setHasMaxDigitsError(true);
      setErrors({
        ...errors,
        spares: t("form-validation.must-have-maximum-digits", {
          label: t(`${LANG_BASE}.fields.spares`),
          max: MAX_DIGITS,
        }),
      });
      return;
    }

    const numberValue = Number(value);

    setInputValue(value);
    setSpares(Number.isNaN(numberValue) ? undefined : numberValue);
    setHasMaxDigitsError(false);

    if (errors.spares) {
      setErrors({
        ...errors,
        spares: undefined,
      });
    }
  };

  const handleBlur = () => {
    if (!hasMaxDigitsError || !errors.spares) return;

    setHasMaxDigitsError(false);
    setErrors({
      ...errors,
      spares: undefined,
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <CustomFormLabel data-testid="spares-label">
        {t(`${LANG_BASE}.fields.spares`)}
      </CustomFormLabel>
      <Input
        type="text"
        inputMode="numeric"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        testId={"spares-input"}
        sx={{ width: "100%" }}
        placeholder={t(`${LANG_BASE}.fields.spares`)}
        fullWidth
      />
      {errors.spares && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
          {errors.spares}
        </Typography>
      )}
    </div>
  );
};

export default SparesField;
